import { ago } from "@/lib/api";

function Row({ label, state, detail, testId }) {
  const cls = state === "ok" ? "live" : state === "warn" ? "warn" : state === "off" ? "idle" : "dead";
  const txt = state === "ok" ? "text-[#0ecb81]" : state === "warn" ? "text-[#fcd535]" : state === "off" ? "text-[#848e9c]" : "text-[#f6465d]";
  return (
    <div className="flex items-center justify-between py-1.5 border-b border-[#1e2329] last:border-0" data-testid={testId}>
      <span className="text-[12px] text-[#eaecef]">{label}</span>
      <span className={`flex items-center gap-2 text-[11px] mono ${txt}`}><span className={`dot ${cls}`} />{detail}</span>
    </div>
  );
}

export function SystemStatusPanel({ status }) {
  if (!status) return <div className="panel p-3 text-xs text-[#5e6673]">Loading status…</div>;
  const md = status.market_data, ai = status.ai_engine, ex = status.exchange_connection;
  const prot = status.risk_engine?.protection_modes || [];
  return (
    <div className="panel p-3" data-testid="system-status-panel">
      <div className="panel-title mb-1">System Status</div>
      <Row label="Exchange Connection" state={ex.connected ? "ok" : "bad"} detail={ex.connected ? `${ex.source} · ${ex.latency_ms ?? "—"}ms` : "DISCONNECTED"} testId="status-exchange" />
      <Row label="Market Data" state={md.connected ? "ok" : "bad"} detail={md.connected ? `live · ${md.latency_ms ?? "—"}ms` : "STALE"} testId="status-market-data" />
      <Row label="AI Engine" state={!ai.enabled ? "off" : ai.last_error ? "warn" : "ok"} detail={!ai.enabled ? "disabled" : ai.last_error ? "fallback (deterministic)" : `${ai.model}${ai.latency_ms ? ` · ${(ai.latency_ms / 1000).toFixed(1)}s` : ""}`} testId="status-ai" />
      <Row label="Risk Engine" state={prot.length ? "warn" : "ok"} detail={prot.length ? prot.join(", ") : "18 rules armed"} testId="status-risk" />
      <Row label="Execution Engine" state={status.kill_switch ? "bad" : status.engine_running ? "ok" : "off"} detail={status.kill_switch ? "HALTED" : status.engine_running ? `running · ${status.execution_engine.orders_submitted} orders` : "idle"} testId="status-execution" />
      <Row label="Trading Mode" state={status.trading_mode === "live" ? "warn" : "ok"} detail={status.trading_mode.toUpperCase()} testId="status-mode" />
      <Row label="Kill Switch" state={status.kill_switch ? "bad" : "ok"} detail={status.kill_switch ? "ACTIVE" : "armed"} testId="status-kill-switch" />
      <div className="text-[10px] text-[#5e6673] mono mt-2">Last analysis cycle: {status.last_cycle ? ago(status.last_cycle) : "never"}</div>
    </div>
  );
}
